class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    // Initialiser le champ de code promo
    this.initPromoCode();
  }

  initPromoCode() {
  const promoCodeButton = document.getElementById('CartDrawer-PromoCodeApply');
  const promoCodeInput = document.getElementById('CartDrawer-PromoCode');
  const promoCodeError = document.getElementById('CartDrawer-PromoCodeError');
  
  if (!promoCodeButton || !promoCodeInput) return;
  
  promoCodeButton.addEventListener('click', (event) => {
    event.preventDefault();
    validateAndApplyPromoCode();
  });
  
  // Permettre la soumission du code promo en appuyant sur Entrée
  promoCodeInput.addEventListener('keypress', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      validateAndApplyPromoCode();
    }
  });
  
  // Fonction pour valider et appliquer le code promo
  const validateAndApplyPromoCode = () => {
    const code = promoCodeInput.value.trim();
    
    // Vérifier si le champ est vide
    if (!code) {
      showPromoMessage('error', 
        window.theme?.strings?.cartPromoCodeEmpty || 'Veuillez entrer un code promo');
      return;
    }
    
    // Afficher l'état de chargement
    const originalButtonText = promoCodeButton.textContent;
    promoCodeButton.disabled = true;
    promoCodeButton.textContent = window.theme?.strings?.cartVerifying || 'Vérification...';
    promoCodeInput.disabled = true;
    
    // Utiliser l'API Fetch pour vérifier le code promo
    fetch('/discount/' + encodeURIComponent(code))
      .then(response => {
        // Vérifier si la réponse est valide
        if (response.ok) {
          // Vérifier si le code promo est valide en examinant la réponse
          return fetch('/cart.js') // Récupérer les informations actuelles du panier
            .then(cartResponse => cartResponse.json())
            .then(cartData => {
              const discountApplied = cartData.total_discount > 0 || 
                                    (cartData.discount_codes && cartData.discount_codes.length > 0);
              
              if (discountApplied) {
                // Code promo valide et appliqué
                addCodeToCheckoutForm(code);
                showPromoMessage('success', 
                  window.theme?.strings?.cartPromoCodeApplied || 'Code promo appliqué');
              } else {
                // Code promo non valide
                showPromoMessage('error', 
                  window.theme?.strings?.cartPromoCodeError || 'Code promo invalide');
              }
            });
        } else {
          // Erreur lors de la requête
          showPromoMessage('error', 
            window.theme?.strings?.cartPromoCodeError || 'Code promo invalide');
        }
      })
      .catch(error => {
        console.error('Erreur lors de la vérification du code promo:', error);
        showPromoMessage('error', 'Erreur lors de la vérification. Veuillez réessayer.');
      })
      .finally(() => {
        // Restaurer l'état des éléments
        promoCodeButton.disabled = false;
        promoCodeButton.textContent = originalButtonText;
        promoCodeInput.disabled = false;
      });
  };
  
  // Fonction pour ajouter le code au formulaire de checkout
  const addCodeToCheckoutForm = (code) => {
    const checkoutForm = document.getElementById('CartDrawer-Form');
    if (!checkoutForm) return;
    
    let promoCodeField = document.getElementById('CartDrawer-PromoCodeField');
    if (!promoCodeField) {
      promoCodeField = document.createElement('input');
      promoCodeField.setAttribute('type', 'hidden');
      promoCodeField.setAttribute('id', 'CartDrawer-PromoCodeField');
      promoCodeField.setAttribute('name', 'discount');
      checkoutForm.appendChild(promoCodeField);
    }
    
    promoCodeField.value = code;
  };
  
  // Fonction pour afficher les messages de statut du code promo
  const showPromoMessage = (type, message) => {
    promoCodeError.style.display = 'block';
    promoCodeError.querySelector('.cart-item__error-text').textContent = message;
    
    // Définir la couleur en fonction du type de message
    if (type === 'success') {
      promoCodeError.style.color = '#008000'; // Vert pour le succès
      promoCodeInput.style.borderColor = '#008000';
    } else if (type === 'error') {
      promoCodeError.style.color = '#EB001B'; // Rouge pour l'erreur
      promoCodeInput.style.borderColor = '#EB001B';
    } else {
      promoCodeError.style.color = '#333'; // Couleur neutre pour les informations
      promoCodeInput.style.borderColor = '';
    }
  };
}









  
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
          const cartDrawerItems = this.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.updateCartUpsellToggleState();
      cartDrawerItems.updateCartUpsellVisibility();
    }

    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
